import { Column, Table } from '@tanstack/react-table';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';

const ColumnFilterSelect = ({
  column,
  filterValue = '',
  filterData = [],
  ...props
}: {
  column: Column<any, unknown>;
  filterValue?: string;
  filterData?: any[];
}) => {

  const data: any[] = useMemo(() => {
    return filterData;
  }, [column.id, filterValue]);

  const [value, setValue] = useState('');

  useEffect(() => {
    column.setFilterValue(value);
  }, [value]);

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      displayEmpty
      inputProps={{ 'aria-label': 'Without label' }}
      {...props}
    >
      {data.map((item: any, index: number) => (
        <MenuItem key={index} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ColumnFilterSelect;